import {Component} from '@angular/core';
import {FormBuilder, FormGroup} from "@angular/forms";
import {AuthService, HistoryHelperService} from 'common-domain';
import {ActivatedRoute, Router} from "@angular/router";
import {gitVersion} from "../../../environments/git-version";
import {TwoFactorGenericComponent} from "../two-factor-generic.component";
import {LoginRecoveryResponseVO} from "../../../../../common-domain/src/lib/model/loginRecoveryResponseVO";
import {LoginResponseVO} from "../../../../../common-domain/src/lib/model/loginResponseVo";
import {PATH_CONSTANTS} from "../../app-routing.module";

@Component({
    selector: 'app-mfa-login-verification-code',
    templateUrl: './mfa-login-verification-code.component.html',
    styleUrls: ['./mfa-login-verification-code.component.scss'],
    standalone: false
})
export class MfaLoginVerificationCodeComponent extends TwoFactorGenericComponent {
  form: FormGroup;
  errorMessage: string;
  constructor(authService: AuthService, formBuilder: FormBuilder, activatedRoute: ActivatedRoute, private historyHelperService: HistoryHelperService, private router: Router) {
    super(authService, formBuilder, activatedRoute);
  }
  onSubmitInfo(token: string, mfaCode: string, decodedToken: any): void {
    if (mfaCode.length === 6) {
      this.onSubmitMfaCode(token, mfaCode);
    } else {
      this.onSubmitRecoveryCode(token, mfaCode);
    }
  }

  onSubmitMfaCode(token: string, mfaCode: string) {
    const buildInfo = gitVersion.commitLong + '-build-' + gitVersion.buildNumber;
    this.authService.login({token, mfaCode, buildInfo, mfaCodeType: 'TOTP'}).subscribe(result => {
      this.storeDetailsAndNavigateAuthenticatedUser(result);
    }, error => {
      if (this.getDecodedAccessToken(token)?.exp < Date.now() / 1000) {
        this.authService.redirectToHome('Token expired', false);
        return;
      }
      if (error.status === 423) {
        let url =  PATH_CONSTANTS.SLASH + "changePassword";
        this.router.navigateByUrl(url);
      }
      else if(error.error?.detail){
        this.errorMessage = error.error.detail;
      } else if(typeof error.error === 'string'){
        this.errorMessage = error.error;
      } else {
        this.errorMessage = 'Invalid two-factor authentication code';
      }
    });
  }
  onSubmitRecoveryCode(token: string, recoveryCode: string): void {
    this.authService.loginRecovery(recoveryCode, token).subscribe(
      {
        next: (authResponse: LoginRecoveryResponseVO) => {
          this.storeDetailsAndNavigateAuthenticatedUser(authResponse);
      },
      error: (error) => {
        if(error.error?.detail){
          this.errorMessage = error.error.detail;
        } else if(typeof error.error === 'string'){
          this.errorMessage = error.error;
        } else {
          this.errorMessage = 'Invalid two-factor authentication code';
        }
      }
    });
  }

  private storeDetailsAndNavigateAuthenticatedUser(authResponse: LoginRecoveryResponseVO | LoginResponseVO) {
    this.authService.storeUserDetails(authResponse);
    this.activatedRoute.queryParams.subscribe(params => {
      const forwardUrl = params?.url;
      if (forwardUrl) {
        this.router.navigateByUrl(forwardUrl);
      } else {
        this.historyHelperService.navigateBack();
      }
    })
  }
}
